export const QUERY_SOLUTION_LOCALE_ZHCHT = {
    saveAsDialog: {
        queryPlanName: 'æ¹æ¡åç¨±',
        setAsDefault: 'è¨­çºé»èª',
        confirm: 'ç¢ºå®',
        cancel: 'åæ¶',
        placeholder: 'è«è¼¸å¥æ¹æ¡åç¨±',
        pleaseInput: 'è«è¼¸å¥æ¹æ¡åç¨±',
        title: 'æ°å¢æ¹æ¡',
        maxLength: 'æ¹æ¡åç¨±è¶åºä¹åå­'
    },
    manageDialog: {
        name: 'åç¨±',
        property: 'å±¬æ§',
        default: 'é»èª',
        operation: 'æä½',
        confirm: 'ç¢ºå®',
        cancel: 'åæ¶',
        planNameDuplicated: 'æ¹æ¡åç¨±{0}éè¤',
        system: 'ä¿çµ±',
        personal: 'åäºº'
    },
    container: {
        default: 'é»èª',
        manage: 'ç®¡ç',
        arrowUp: 'æ¶èµ·',
        arrowDown: 'å±é',
        saveAs: 'å¦å­çºæ¹æ¡',
        empty: 'ç©º',
        save: 'ä¿å­æ¹æ¡',
        pleaseInput: 'formIdçºå¿å³å­æ®µï¼è«å³å¥',
        saveSuccess: 'æ¥è©¢æ¹æ¡ä¿å­æå',
        saveFail: 'æ¥è©¢æ¹æ¡ä¿å­å¤±æ',
        planManage: 'æ¹æ¡ç®¡ç',
        clear: 'æ¸ç©º',
        require: 'è«å¡«å¯«{fields}åé²è¡ç¯©é¸',
        defaultName: 'é»èªç¯©é¸æ¹æ¡',
        histroyName: 'ä¸æ¬¡ç¯©é¸',
        sysPresetName: 'ç³»ç»é¢ç½®æ¹æ¡'
    }
};
